<template>
  <section class="content">
    <div class="box box-info">
      <!-- <div class="p-toolbar p-component mb-4">
        <button class="p-button p-component p-button-help exportBtn" type="button" @click.prevent="exportCSV()" v-if="this.customerLists.length > 0">
          <span class="pi pi-upload p-button-icon p-button-icon-left"></span><span class="p-button-label">Export</span>
          <span class="p-ink"></span>
        </button>
        <customeraccountdialog ref="openDialog"/>
      </div> -->
      <Dialogs header="Reason" :visible.sync="ecommerceStatusDialog"
                   :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="col-md-12">
              <label for="reason" class="col-md-4 control-label">Reason</label>
              <div class="form-group col-md-8">
                <textarea class="form-control" rows="5" v-model="reason"></textarea>
              </div>
            </div>


            <div class="p-fluid p-formgrid p-grid" style="flex-flow: row-reverse;">
              <div class="p-field p-col-12 p-md-2">
                <Button class="p-button-raised p-button-danger" @click.prevent="cancel"
                        label="Cancel"/>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <Button class="p-button-raised p-button-success" @click.prevent="updateOrderStatus"
                        label="Update"/>
              </div>

            </div>

          </Dialogs>

      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
          <DataTable ref="po" :value="customerFollowUpLists" :paginator="true" :rows="100"
            :rowsPerPageOptions="[100, 500, 1000]" :filters="filters" class="p-datatable-responsive p-datatable-gridlines">
            <Column header="S.n">
              <template #body="slotProps">
                {{ slotProps.index + 1 }}
              </template>
            </Column>
            <Column :sortable="true" header="Name" field="name" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['name']" />
              </template>
            </Column>


            <Column :sortable="true" header="Contact name" field="contactName" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['contactName']" />
              </template>
            </Column>

            <Column :sortable="true" header="Contact Number" field="primaryContactNumber" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['primaryContactNumber']" />
              </template>
            </Column>

            <Column :sortable="true" header="Follow Up Days" field="followUpDays" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['followUpDays']" />
              </template>
            </Column>

            <Column :sortable="true" header="Follow Up Date" field="nextFollowUpDateNepali" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['nextFollowUpDateNepali']" />
              </template>
            </Column>

            <Column field="followUpStatus" header="FollowUp Status" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['followUpStatus']" />
              </template>
              <template #editor="slotProps">
                <Dropdown v-model="slotProps.data['followUpStatus']" :options="statuses"
                  @change="showReasonDialog(slotProps.data)" optionLabel="label" optionValue="value"
                  placeholder="Select status" :disabled="slotProps.data['followUpStatus'] === 'Completed' ? true : false">
                  <template #option="slotProps">
                    <span>{{ slotProps.option.label }}</span>
                  </template>
                </Dropdown>
              </template>
              <template #body="slotProps">
                {{ getStatusLabel(slotProps.data.followUpStatus) }}
              </template>

            </Column>

            <Column :sortable="true" header="Closing Balance" field="closingBalance" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['closingBalance']" />
              </template>
            </Column>

            <Column :sortable="true" header="Dr-Cr" field="drCr" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['drCr']" />
              </template>
            </Column>
            <Column :sortable="true" header="Status" field="status" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['status']" />
              </template>
            </Column>
            <Column header="Action" headerStyle="width: 11em">
              <template #body="slotProps">


                <!-- <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                          @click="editCustomer(slotProps.data)"/>
   -->
                <!-- <Button icon="pi pi-trash" class="p-button-danger p-button-sm"
                          @click="openDialog(slotProps.data.id)"/> -->
                <Button icon="pi pi-check" class="p-button-raised p-button-success"
                  @click="verifyCustomer(slotProps.data.id)" />
              </template>
            </Column>


          </DataTable>
        </div>
      </div>
    </div>
    <!-- </div>
      </div> -->
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteAccountMaster" />

  </section>
</template>
<script>
import customeraccountdialog from '../accountDialog/CustomerAccountDialog.vue'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Dialogs from 'primevue/dialog'

export default {
  name: 'customer',
  data() {
    return {
      displayBasic: false,
      dialogShow: false,
      accountMasterDetailsId: 0,
      statusData: '',
      reason: '',
      ecommerceStatusDialog: false,
      columnList: '',
      statuses: [{ label: 'Processing', value: 'Processing' }, { label: 'Hold', value: 'Hold' }, {
        label: 'Completed',
        value: 'Completed'
      }, { label: 'Cancelled', value: 'Cancelled' }],
      filters: {}
    }
  },
  computed: {
    customerFollowUpLists() {
      return this.$store.state.accountMaster.customerFollowUpLists
    }
  },
  mounted() {
    this.customerFollowUpList()
    this.columnNames()
  },
  methods: {
    async deleteAccountMaster(value) {
      if (value.trim() === '') {
        this.$toast.add({ severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000 })
        this.dialogShow = true
        return
      }
      let deleteRe = {
        accountMasterId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteAccMaster', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({ severity: 'success', summary: '', detail: resp.data.message, life: 10000 })
        this.closeDialog()
        this.dialogShow = false
      } else {
        this.$toast.add({ severity: 'error', summary: '', detail: resp.data.message, life: 10000 })
        this.dialogShow = false
        this.closeDialog()
      }
    },
    async verifyCustomer(value) {
      let deleteRe = {
        accountMasterId: value,
        verify: true
      }
      let resp = await this.$store.dispatch('verifyCustomer', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({ severity: 'success', summary: '', detail: resp.data.message, life: 10000 })
      } else {
        this.$toast.add({ severity: 'error', summary: '', detail: resp.data.message, life: 10000 })
      }
    },
    editCustomer(data) {
      this.$refs.openDialog.editCustomer(data)
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Customer List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), { type: response.data.type })
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'customerList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    async customerFollowUpList() {
      await this.$store.dispatch('loadCustomerFollowUpAccountList')
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    },
    cancel(data) {
      this.dialogShow = false
    },
    showReasonDialog(data) {
      this.accountMasterDetailsId = data.id
      this.statusData = data.orderStatus
      this.ecommerceStatusDialog = true
      this.reason = '-'
      this.updateOrderStatus()
    },
    async updateOrderStatus() {
      let data = {
        id: this.accountMasterDetailsId,
        followUpStatus: this.statusData,
        followUpRemarks: this.reason
      }
      let resp = await this.$store.dispatch('updateFollowUpStatus', data)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reason = ''
        this.ecommerceStatusDialog = false
      }
    },
    getStatusLabel(status) {
      switch (status) {
        case 'Processing':
          return 'Processing'

        case 'Hold':
          return 'Hold'

        case 'Completed':
          return 'Completed'

        case 'Cancelled':
          return 'Cancelled'

        default:
          return 'NA'
      }
    }
  },
  components: {
    Column,
    DataTable,
    Dialog,
    InputText,
    Dialogs,
    customeraccountdialog,
    Button
  }
}
</script>



// WEBPACK FOOTER //
// followUpCustomerList.vue?0c2d1704